import React from 'react'
import { BusinessSiteDto, UserRoleDto } from '../Requests/useGetUsers'

export interface UserStatus {
  busy: boolean;
  login: () => void;
  user: (UserProfile | KaEmployeeProfile | null);
  refreshUser: () => Promise<void>
}

export enum LoginType {
  KaEmployee,
  User
}

export interface Profile {
  id: string;
  userType: LoginType.User | LoginType.KaEmployee;
  fetchHeaders: () => Promise<Headers>;
  signOut: () => void;
  email: string;
  businesses: Business[];
  selectedBusiness: Business | null;
}

export interface KaEmployeeProfile extends Profile {
  userType: LoginType.KaEmployee;
  canEditBusinesses: boolean;
  canViewNotifications: boolean;
  canViewSiteStatus: boolean;
  canViewOrders: boolean;
  canViewIntegrations: boolean;
  setSelectedBusiness: (business: Business | null) => void;
  refreshUser: () => Promise<void>;
}

export interface UserProfile extends Profile {
  userType: LoginType.User;
  userAgreementInfo: UserAgreementInfo;
  isDevelopment: boolean;
  businesses: UserBusiness[];
  hasConflictingSignInMethod: boolean;
  signOut: () => void;
  selectedBusiness: UserBusiness | null;
  setSelectedBusiness: (business: UserBusiness | null) => void;
}

export interface Integration {
  name: string;
  configurationUri: string;
}

export interface Business {
  id: string;
  name: string;
  integrations: Integration[];
}

export interface UserBusiness extends Business {
  administrator: boolean;
  userRole: UserRoleDto;
  siteAllowance: number;
  numberOfSites: number;
  usesDataSharing: boolean;
  disabled: boolean;
  sandbox: boolean;
  siteRestricted: boolean;
  assignedSites: BusinessSiteDto[];
}

export interface UserAgreementInfo {
  hasAcceptedUserAgreement: boolean;
  url: string;
}

export const UserContext = React.createContext<UserStatus>({ busy: false, user: null, login: () => { }, refreshUser: () => new Promise(() => { }) });
